import { axiosGateway } from '@/services/axiosTools'
// import Cookie from 'js-cookie'
export function getCustomApp(params) {
    return axiosGateway.get({
        url: `/cloud-pcmgr-deskframe/rest/customizesidebar/v1/release`,
        gatewayKey: 'baseURL3',
        headers: {
            // authorization: Cookie.get('slbrowser_pc_ai_assist_authorization'),
            timeout: 1000 * 120,
        },
        params
    })
}
